<div class="flex flex-wrap mt-8 mb-6">

    @let loading = (loading$ | async) ?? false;
    @let myRoles = myRoles$ | async;

    <div class="w-full flex flex-row justify-between mb-4">
        <app-btn-back routeTo=".."></app-btn-back>
        <div class="flex gap-2 justify-center">
            @if (myRoles?.management && group?.memberStatus ==
            membershipStatus.active) {
            <app-btn-action label="New Grade" [isDisabled]="loading" (clicked)="onAddGrade()" bgColor="bg-primary-500"
                icon="fa fa-add"></app-btn-action>
            }
        </div>
    </div>

    <div class="mb-4 border-0 w-full">
        <h1 class="font-semibold text-2xl capitalize text-blueGray-700">
            Grades [{{group?.academicYear}}]
        </h1>
    </div>

    <list-utils-bar [searchDisabled]="true" (valueChanged)="onSearchTermChange($event)" (onRefresh)="onRefresh()"
        class="w-full"></list-utils-bar>

    <div class="flex w-full flex-col gap-4">
        @for (item of grades$ | async; track item.id) {
        @if(item.gradeName.toLowerCase().includes(searchTerm?.toLowerCase() ?? '')) {
        <div class="bg-white shadow-lg rounded w-full px-4 py-3">
            <a class="cursor-default flex flex-col gap-2">
                <div class="flex items-center justify-between flex-row w-full">
                    <div class="flex flex-row flex-nowrap items-center gap-2">
                        <p [routerLink]="[item.id]"
                            class="text-center cursor-pointer font-semibold whitespace-nowrap truncate">{{
                            item.gradeName }}</p>
                        <app-btn-chip [label]="item.gradeStatus"
                            [color]="item.gradeStatus == gradeStatus.active ? 'text-green-700' : 'text-primary-500'"
                            [bgColor]="item.gradeStatus == gradeStatus.active ? 'bg-green-50' : 'bg-gray-100'"></app-btn-chip>
                    </div>

                    @if(myRoles?.management) {
                    <div class="relative flex md:hidden justify-end">
                        <app-btn-fab (click)="toggleDropdown(item.id!, $event)" #btnDropdownRef
                            icon="fas fa-ellipsis-vertical"></app-btn-fab>
                        <div class="absolute right-0 top-full mt-1 min-w-48 z-50 {{ activeDropdownGradeId === item.id ? 'block' : 'hidden'}}"
                            #popoverDropdownRef>
                            <div
                                class="bg-white text-base py-2 list-none text-left rounded shadow-lg min-w-48 border border-gray-100">
                                <a (click)="onAssignFaculty(item)" class="cursor-pointer active:border-none text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent
                                                                                                text-blueGray-700">
                                    <i class="fas fa-id-card-clip mr-2 leading-relaxed"></i>
                                    Assign Teacher
                                </a>
                                <a (click)="onEditGrade(item)" class="cursor-pointer active:border-none text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent
                                                                                        text-blueGray-700"><i
                                        class="fas fa-edit mr-2 leading-relaxed"></i>
                                    Edit
                                </a>
                                <a (click)="onArchiveGrade(item)" class="cursor-pointer active:border-none text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent
                                                        text-blueGray-700"><i
                                        class="far fa-file-zipper mr-2 leading-relaxed"></i>
                                    Archive
                                </a>

                                <a (click)="onDeleteGrade(item)" class="cursor-pointer active:border-none text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent
                                                            text-blueGray-700">
                                    <i class="fas fa-gear mr-2 leading-relaxed"></i>
                                    Delete
                                </a>
                            </div>
                        </div>
                    </div>

                    <div class="hidden md:flex flex-row gap-2 whitespace-nowrap">
                        <app-btn-fab (click)="onAssignFaculty(item)" icon="fas fa-id-card-clip"
                            tooltip="Assign Teacher"></app-btn-fab>
                        <app-btn-fab (click)="onEditGrade(item)" icon="fas fa-edit"
                            tooltip="Update Grade"></app-btn-fab>
                        <app-btn-fab (click)="onArchiveGrade(item)" icon="far fa-file-zipper"
                            tooltip="Archive"></app-btn-fab>
                        <app-btn-fab (click)="onDeleteGrade(item)" icon="fa fa-trash-can"
                            textColor="text-red-500 disabled:text-gray-200" tooltip="Delete"></app-btn-fab>
                    </div>
                    }
                </div>
                <div class="flex items-center gap-2">
                    <div class="inline-block flex-none">
                        @if(item.teacherPhotoUrl) {
                        <img [src]="item.teacherPhotoUrl"
                            class="min-h-8 max-h-8 max-w-8 min-w-8 bg-gray-100 object-cover rounded-full border-none" />
                        } @else {
                        <div
                            class="bg-primary-100 uppercase text-primary-500 text-sm flex justify-center items-center text-center h-8 w-8 rounded-full">
                            {{ item.teacherName ?? 'N A' | initials }}
                        </div>
                        }
                    </div>
                    <div class="flex-1 inline-flex flex-span text-sm text-blueGray-600">
                        <span>{{item.teacherName ?? 'Unassigned' | titlecase}}</span>
                    </div>
                </div>
            </a>
        </div>
        }
        } @empty {
        @if(!loading) {
        <div class="px-6 py-4 text-center font-semibold border-0 whitespace-nowrap">
            No Grades Found
        </div>
        }
        }
        @if(loading) {
        <div class="bg-white shadow-lg rounded p-4 mt-1 w-full mx-auto">
            <div class="animate-pulse flex space-x-4">
                <div class="flex-1 space-y-2">
                    <div class="h-3 w-1/4 bg-slate-200 rounded"></div>
                    <div class="h-4 w-2/3 bg-slate-200 rounded"></div>
                    <div class="space-y-2">
                        <div class="flex flex-row gap-2 justify-start items-center">
                            <div class="h-6 w-6 bg-slate-200 rounded-full"></div>
                            <div class="h-4 w-1/4 bg-slate-200 rounded"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        }

    </div>

    <div class="flex flex-row w-full justify-center px-4 mt-3">
        <app-btn-more (click)="addMore()"
            [isDisabled]="((loading$ | async) ?? false) || groupId == null"></app-btn-more>
    </div>
</div>